import styled from "styled-components";

export const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  gap: 1rem;
  padding-block: 1rem;
  li {
    background-color: var(--background-secondary-color);
    padding: 5px;
    box-shadow: 0 0.5rem 1rem -0.25rem black;
    border-radius: 4px;
    color: var(--text-color);
  }
`;

export const Wrapper = styled.section`
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  div[data-animated="true"] {
    overflow: hidden;
  }
  div[data-direction="right"] {
    --_animation-direction: reverse;
  }
  div[data-direction="left"] {
    --_animation-direction: forwards;
  }
  div[data-speed="slow"] {
    --_animation-duration: 120s;
  }
  div[data-speed="fast"] {
    --_animation-duration: 2s;
  }

  div[data-animated="true"] {
    mask: linear-gradient(
      90deg,
      transparent,
      white 20%,
      white 80%,
      transparent
    );
    -webkit-mask: linear-gradient(
      90deg,
      transparent,
      white 20%,
      white 80%,
      transparent
    );
    ul {
      width: max-content;
      flex-wrap: nowrap;
      animation: scroll var(--_animation-duration, 40s)
        var(--_animation-direction, forwards) linear infinite;
      @keyframes scroll {
        to {
          transform: translate(calc(-50% - 0.5rem));
        }
      }
    }
  }
`;

export const Scroller = styled.div`
  max-width: 100%;
  /* outline: 5px solid lime; */
`;
